module.exports = __webpack_public_path__ + "img/sgq-icon.34069186.svg";